import { IListarEtapas } from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import {
    TModoGestaoAtendimento,
    IListarVendasResponse,
    IAtendimentoVendasRequest,
} from "../../../Interfaces/Vendas/GestaoAtendimentos/AtendimentosVendas";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarAtendimentosVendasService<
    TResponseType extends IListarVendasResponse | Blob
>(
    data: IAtendimentoVendasRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    expExcel?: boolean
) {
    return Service(
        Axios.post<TResponseType>(
            `/Vendas/AtendimentosVendas/ListarAtendimentos?ID_PAGINA=${pagina}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&expExcel=${expExcel}`,
            data,
            { responseType: pagina === 0 ? "blob" : "json" }
        )
    );
}

export async function ListarAtendimentosVendasTransferirService(
    data: IAtendimentoVendasRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Service(
        Axios.post<IListarVendasResponse>(
            `/Vendas/AtendimentosVendas/ListarAtendimentos?ID_PAGINA=${0}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&expExcel=${false}`,
            data
        )
    );
}

export async function ListarEtapasCasoVendasService(
    ID_CASO: number
) {
    return Service(
        Axios.get<Array<IListarEtapas>>(
            `/Vendas/AtendimentosVendas/ListarEtapasCasoVendas?ID_CASO=${ID_CASO}`
        )
    );
}

export function AvancarEtapaService(
    idCaso: number,
    idEtapaDestino: number
) {
    return Service(
        Axios.post(`/Vendas/AtendimentosVendas/AvancarEtapa?idCaso=${idCaso}&idEtapaDestino=${idEtapaDestino}`)
    );
}